export const SET_YEAR = 'SET_YEAR';
export const SET_EVENTS = 'SET_EVENTS';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const SET_LOADING = 'SET_LOADING';

export const GOOGLE_CLIENT_LOADED = 'GOOGLE_CLIENT_LOADED';
export const USER_SIGN_IN = 'USER_SIGN_IN';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';

export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
